import { Controller } from '@hotwired/stimulus';

// Bridges the right-side panel to its sibling annotation-viewer canvas.
// On every connect — initial mount AND every turbo_stream replace of
// annotations-panel-{id} — asks the viewer to re-render pins so the
// numbered overlays stay in sync with create/destroy mutations.
export default class extends Controller {
  connect() {
    const viewer = this.element.closest('[data-controller~="annotation-viewer"]');
    if (!viewer) return;
    viewer.dispatchEvent(new CustomEvent('annotation:refresh', { bubbles: false }));
  }
}
